(() => {
  // 1) HARD OVERRIDE: prevent Sami from hiding grid/recommendation price blocks
  // Inline style "display:none" loses to author CSS if author uses !important.
  const ensureStyle = () => {
    if (document.getElementById('sami-grid-price-override')) return;

    const style = document.createElement('style');
    style.id = 'sami-grid-price-override';
    style.textContent = `
      /* When Sami injected both prices, ALWAYS show the price block (collections, search, recommendations slider, etc.) */
      .card-information .price[samitaws-product-price]:has(.samitaWS-customized-price):has(.samitaWS-customized-original-price) {
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(style);
  };

  // 2) JS SAFETY: in case Sami replaces nodes or browser lacks :has support
  const fixGridWholesalePrice = () => {
    ensureStyle();

    document
      .querySelectorAll('.card-information .price[samitaws-product-price]')
      .forEach((priceEl) => {
        const hasWholesale = !!priceEl.querySelector('.samitaWS-customized-price');
        const hasCompareAt = !!priceEl.querySelector('.samitaWS-customized-original-price');

        // Only when Sami rule applied AND compare-at exists
        if (!hasWholesale || !hasCompareAt) return;

        // Remove Sami inline hide if present
        if (priceEl.style?.display === 'none') priceEl.style.removeProperty('display');

        // Force visible
        priceEl.style.setProperty('display', 'block', 'important');
        priceEl.style.setProperty('visibility', 'visible', 'important');
        priceEl.style.setProperty('opacity', '1', 'important');
      });
  };

  // tiny debounce so MutationObserver doesn't thrash
  let raf = null;
  const scheduleFix = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = null;
      fixGridWholesalePrice();
    });
  };

  // Run at key moments
  window.addEventListener('samitaWSRenderWholesaleCompleted', () => {
    fixGridWholesalePrice();
    setTimeout(fixGridWholesalePrice, 50);
    setTimeout(fixGridWholesalePrice, 200);
    setTimeout(fixGridWholesalePrice, 600);
  });

  document.addEventListener('DOMContentLoaded', () => {
    fixGridWholesalePrice();
    setTimeout(fixGridWholesalePrice, 200);
    setTimeout(fixGridWholesalePrice, 800);
  });

  // Watch for product grid / recommendations being injected/replaced
  const mo = new MutationObserver(scheduleFix);
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Initial
  fixGridWholesalePrice();
})();
